import { render, staticRenderFns } from "./ReservationComplete.vue?vue&type=template&id=2a0d58ae&scoped=true&"
import script from "./ReservationComplete.vue?vue&type=script&lang=js&"
export * from "./ReservationComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d58ae",
  null
  
)

export default component.exports